import React from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Typography from '@material-ui/core/Typography'
import Checkbox from 'ui/components/checkbox'
// import Badge from 'ui/components/badge'
import useStyles from './stylesItem'
// import useTranslation from 'hooks/useTranslations'

const Item = props => {
  const {
    id,
    title,
    subtitle,
    onSelect,
    isSelected,
    //   totalResults,
    linkTo,
  } = props

  // const t = useTranslation()

  const classes = useStyles()

  const itemSelect = e => {
    e.stopPropagation()
    e.preventDefault()
    onSelect(id)
  }

  return (
    <ListItem
      className={clsx(classes.root, isSelected && classes.isChecked)}
      button
      component={Link}
      to={linkTo}
      divider
      role="listitem"
      ContainerProps={{ className: classes.item }}
    >
      <ListItemIcon className={classes.itemIcon}>
        <Checkbox
          className={classes.itemCheckbox}
          edge="start"
          color="primary"
          onClick={itemSelect}
          checked={isSelected}
          tabIndex={-1}
          disableRipple
        />
      </ListItemIcon>
      <ListItemText
        className={classes.itemText}
        disableTypography
        primary={
          <Typography variant="body2" noWrap>
            {title}
          </Typography>
        }
        secondary={subtitle}
      />
      {/*
      <ListItemSecondaryAction className={classes.itemActions}>
        <Badge label={t('searches:total-results', { total: totalResults })} />
      </ListItemSecondaryAction>
      */}
    </ListItem>
  )
}

Item.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  onSelect: PropTypes.func,
  isSelected: PropTypes.bool,
  totalResults: PropTypes.number,
  linkTo: PropTypes.string,
}

export default Item
